import {Pipe, PipeTransform} from "@angular/core";
import {Media, MediaType} from "@models";

@Pipe({
	name: "mediaFilter",
	pure: true,
	standalone: false,
})
export class MediaFilterPipe implements PipeTransform {
	transform(medias: Media[], mediaType: MediaType): Media[] {
		if (!medias) {
			return [];
		}

		return medias.filter((media) => {
			return media.mediaType === mediaType;
		});
	}
}
